module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "hours"
  }, [_vm._v("\n        Mon. - Fri., 10AM - 8PM\n      ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "email"
  }, [_c('a', {
    attrs: {
      "href": ("mailto:" + _vm.email)
    }
  }, [_vm._v(_vm._s(_vm.email))])]), _vm._v(" "), _c('button', {
    staticClass: "modal-close is-large close",
    on: {
      "click": function($event) {
        _vm.dismiss()
      }
    }
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "email-description"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-envelope-o"
  })]), _vm._v("\n        Get in touch via email, we'll be sure to respond within 48 hours.\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1d6a090b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 280
// module chunks = 1